/* eslint-disable @typescript-eslint/no-explicit-any */
import DictionaryJson from '../../../../main/translate/dictionary.json';
import { Dictionary } from '../../../../main/translate/dictionary/dictionary';
import { LanguageKey } from '../../../../main/translate/language-key/language-key';
import {
  Language,
  languages,
} from '../../../../main/translate/language/language';
import { LocationId } from '../../../../main/translate/location-id/location-id';
import { EventTopic } from '../../../../models/common/event-topic/event-topic';
import { IEventService } from '../event/event-service';
import { ILogService } from '../log/log-service';
import { ITranslateService } from './translate-service';

export class TranslateServiceImpl implements ITranslateService {
  private language: Language;
  private dictionary: Dictionary;

  constructor(
    private logService: ILogService,
    private eventService: IEventService,
  ) {}

  async init(location: LocationId = 'pt-BR'): Promise<void> {
    if (!this.dictionary || location !== this.language?.id) {
      await this.logService.info('Inicializando tradução para ', location);
      this.language = languages.get(location);
      this.dictionary = DictionaryJson;
      this.eventService.emit(EventTopic.LANGUAGE_CHANGED, location);
    }
  }

  translateKey(key: LanguageKey): string {
    const safeDictionary = this.dictionary || DictionaryJson;
    const safeLanguage = this.language || languages.get('pt-BR');
    const translated = safeDictionary?.[key]?.[safeLanguage?.id] || key;

    this.dictionary = safeDictionary;
    this.language = safeLanguage;
    return translated;
  }

  translateText(text: string): string {
    return text;
  }

  isLanguageKey(value: any): value is LanguageKey {
    return Object.values(LanguageKey).includes(value);
  }
}
